import { useParams } from "react-router-dom";

export const useExcludedIPEditPageParams = () => {
  const { siteSlug = "", excludedIpSlug = "" } = useParams();

  return { siteSlug, excludedIpSlug };
};
